export default "__VITE_ASSET__1_52SgIw__"